<form (ngSubmit)="onSubmit()" novalidate>
  <section>
    <mat-form-field>
      <input
        type="text"
        placeholder="Add Organisation"
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto"
        />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="updateOrgs($event)"
        [displayWith]="displayOption"
        >
        @for (option of filteredOrgs; track option) {
          <mat-option [value]="option">
            {{option.title}}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <section>
      <h2>Existing Organisations</h2>
      @if (!userOrgs.value.length) {
        <p>
          The user has no assigned organisations
        </p>
      }
      @if (userOrgs.value) {
        <ul>
          @for (org of userOrgs.value; track org) {
            <li>
              <span>{{ org['title'] }}</span
                ><span
                ><button
                (click)="deleteItem(org)"
                mat-icon-button
                matTooltip="Remove user from org"
                type="button"
                >
                <mat-icon>delete</mat-icon>
              </button></span
              >
            </li>
          }
        </ul>
      }
    </section>
  </section>
</form>
